// types
import type { className } from '../../../types/components/card';

interface CardBodyStylesType {
  defaultProps?: {
    className?: className;
  };
  styles?: {
    base?: object;
  };
}

const cardBody: CardBodyStylesType = {
  defaultProps: {
    className: '',
  },
  styles: {
    base: {
      p: 'p-6',
    },
  },
};

export default cardBody;
